import { AppApiGateway } from '@repo/api/web/AppApiGateway'
import type {
  ContentListRequestQuery,
  PageOfShowcaseContentListItemDto,
  ShowcaseContentItemDto,
  ShowcaseContentSitemapEntryDto,
} from '@repo/api/web/models'
import { inject, injectable } from 'inversify'

@injectable()
export class ContentService {
  private readonly appConfig: ReturnType<typeof useAppConfig>

  constructor(@inject(AppApiGateway) readonly api: AppApiGateway) {
    this.appConfig = useAppConfig()
  }

  list(query: ContentListRequestQuery): Promise<PageOfShowcaseContentListItemDto> {
    return this.api.contentList(this.appConfig.host, query)
  }

  getBySlug(slug: string): Promise<ShowcaseContentItemDto> {
    return this.api.contentGetBySlug(slug, this.appConfig.host)
  }

  sitemap(): Promise<Array<ShowcaseContentSitemapEntryDto>> {
    return this.api.contentSitemap(this.appConfig.host)
  }
}
